<div class="margin-top container fill">
  <div class="row">
    <div *ngIf="errorMsgShow">
      <span class="text-center" style="color:red;">{{errorMsg}}</span>
    </div>
  </div>
</div>
